import { Col } from "antd";
import React from "react";
import ViewAllJobs from "./Job/ViewAllJobs";

export const HomeContent = (props) => {
  return (
    <Col>
      <ViewAllJobs />
    </Col>
  );
};

export default HomeContent;
